const APP_BACKEND_HOST = window.hostName.APP_BACKEND_HOST;

export const APIUrlConstants = {
    GetScreens: `${APP_BACKEND_HOST}api/GetScreens`,
    GetReports: `${APP_BACKEND_HOST}api/GetReports`,
    RetrieveScreenInfo: `${APP_BACKEND_HOST}api/RetrieveScreenData`,
    ExecuteScreenAction: `${APP_BACKEND_HOST}api/ExecuteScreenAction`,
    GetNGLTeamDailyReportData: `${APP_BACKEND_HOST}api/GetNGLTeamDailyReportData`,
    GetNGLTowerConstraints: `${APP_BACKEND_HOST}api/GetTowerConstraintsDailyRollUpdata`,
    SaveNGLTowerConstraints: `${APP_BACKEND_HOST}api/SaveTowerConstraintsReason`,
    GetNGLTowerConstraintsComments: `${APP_BACKEND_HOST}api/GetTowerConstraintsComments`,
    SaveNGLTowerConstraintsComments: `${APP_BACKEND_HOST}api/SaveTowerConstraintsComments`,
    SaveNGLTeamDailyReportData: `${APP_BACKEND_HOST}api/SaveNGLTeamDailyReportData`,
    GetOutageScheduleReportData: `${APP_BACKEND_HOST}api/GetScheduleOutageReportData`,
    GetOutageLoggedInUserInfo: `${APP_BACKEND_HOST}api/GetOutageLoggedInUserInfo`,
    SaveOutageScheduleReportData: `${APP_BACKEND_HOST}api/SaveScheduleOutageReportData`,
    SaveUserFacilityMappingData: `${APP_BACKEND_HOST}api/SaveUserMappingData`,
    UploadReleaseIncidentFile: `${APP_BACKEND_HOST}api/UploadReleaseIncidentFile`,
    GetReleaseIncidentFiles: `${APP_BACKEND_HOST}api/GetReleaseIncidentFiles`,
    GetLeakDetections: `${APP_BACKEND_HOST}api/releaseincident/GetLDSResponseFormDetails`,
    SaveLeakDetectionResponseForm: `${APP_BACKEND_HOST}api/releaseincident/SaveLeakDetectionResponseForm`,
    LeakDetectionStatusUpdate: `${APP_BACKEND_HOST}api/releaseincident/UpdateLDSResponseStatus`,
    sendMailApi: `${APP_BACKEND_HOST}api/releaseincident/SendLDSApprovalMail`,
    UpdateApprovedByReleaseIncident: `${APP_BACKEND_HOST}api/releaseincident/UpdateApprovedByReleaseIncident`,
    ExportResponseForm: `${APP_BACKEND_HOST}api/releaseincident/ExportResponseForm`,
    GetIncidentByEvent: `${APP_BACKEND_HOST}api/releaseincident/getincidentbyevent/{eventid}`,

    GetNominationData: `${APP_BACKEND_HOST}api/nomination/getdata`,
    SaveNominationData: `${APP_BACKEND_HOST}api/nomination/savedata`,
    GetNominationAudit: `${APP_BACKEND_HOST}api/nomination/getaudit`,

    DownloadReleaseIncidenFile: `${APP_BACKEND_HOST}api/DownloadReleaseIncidentFile`,
    GetOutageScheduleEditData: `${APP_BACKEND_HOST}api/GetScheduleOutageToEdit`,
    GetOutageCommentsData: `${APP_BACKEND_HOST}api/GetScheduleOutageComments`,
    GetScreensWrapper: `${APP_BACKEND_HOST}api/GetScreensWrapper`,
    GetGeneratorVendorHeader: `${APP_BACKEND_HOST}api/generator/vendor/header`,
    GetGeneratorVendorData: `${APP_BACKEND_HOST}api/generator/vendor/list`,
    UpdateVendorData: `${APP_BACKEND_HOST}api/generator/vendor/update`,
    SaveOutageUserData: `${APP_BACKEND_HOST}api/SaveScheduleOutageUserData`,
    GetPriceChanges: `${APP_BACKEND_HOST}api/GetPriceChanges`,
    GetMarketingRepList: `${APP_BACKEND_HOST}api/GetMarketingRepList`,
    SendMailMarketingRep: `${APP_BACKEND_HOST}api/SendMailMarketingRep`,
    GetUserProfile: `${APP_BACKEND_HOST}api/GetUserProfile`,
    SaveUserProfile: `${APP_BACKEND_HOST}api/SaveUserProfile`,
    ResetUserProfile: `${APP_BACKEND_HOST}api/ResetUserProfile`,
    GetGainLossPMCTransactionData: `${APP_BACKEND_HOST}api/gainLoss/transaction/getPMCTransactionScreenData`,
    GetGainLossPAATransactionData: `${APP_BACKEND_HOST}api/gainLoss/transaction/getPAATransactionScreenData`,
    UpdateGainLossPMCTransactionData: `${APP_BACKEND_HOST}api/gainLoss/pmc/transaction/update`,
    UpdateGainLossPAATransactionData: `${APP_BACKEND_HOST}api/gainLoss/paa/transaction/update`,
    GetEntityList: `${APP_BACKEND_HOST}api/gainLoss/list/getEntityList`,
    CreateEntity: `${APP_BACKEND_HOST}api/gainLoss/list/createEntity`,
    UpdateEntity: `${APP_BACKEND_HOST}api/gainLoss/list/updateEntity/{listId}`,
    GetEntityTypes: `${APP_BACKEND_HOST}api/gainLoss/list/getEntityTypes`,
    GetGainLossReferenceHeader: `${APP_BACKEND_HOST}api/gainLoss/reference/getJurisdiction`,
    GetGainLossReferenceData: `${APP_BACKEND_HOST}api/gainLoss/reference/getReferenceScreenData`,
    GetGainLossProductsData: `${APP_BACKEND_HOST}api/gainLoss/reference/getProducts`,
    SaveReferenceScreenData: `${APP_BACKEND_HOST}api/gainloss/reference/update`,
    SaveProductData: `${APP_BACKEND_HOST}api/gainloss/products/update`,
    GetProductionMonths: `${APP_BACKEND_HOST}api/gainLoss/getProductionMonths`,
    GetTransactionAuditData: `${APP_BACKEND_HOST}api/gainLoss/getTransactionAudit`,
    GetUnitPrice: `${APP_BACKEND_HOST}api/gainloss/unitPrice/getUnitPrices`,
    SaveUnitPrice: `${APP_BACKEND_HOST}api/gainLoss/unitPrice/saveUnitPrice`,
    GetPMCSystemVarianceData: `${APP_BACKEND_HOST}api/gainLoss/pmc/system/variance`,
    GetPAASystemVarianceData: `${APP_BACKEND_HOST}api/gainLoss/paa/system/variance`,
    SaveSystemVarianceData: `${APP_BACKEND_HOST}api/gainLoss/system/variance/createorupdate`,
    FetchEABS: `${APP_BACKEND_HOST}api/gainLoss/FetchEABS`,
    FetchFBS: `${APP_BACKEND_HOST}api/gainLoss/FetchFBS`,
    FetchHW: `${APP_BACKEND_HOST}api/gainLoss/FetchHighWire`,
    GetSubSystemVarianceScreenData: `${APP_BACKEND_HOST}api/gainLoss/subSystemVariance/getSubSystemVarianceScreenData`,
    SaveSubSystemVarianceScreenData: `${APP_BACKEND_HOST}api/gainloss/subSystemVariance/update`,
    GetSubSystemVarianceAuditHistory: `${APP_BACKEND_HOST}api/gainLoss/subSystemVariance/getSubSystemVarianceAuditHistoryData`,
    GetSystemVarianceAuditData: `${APP_BACKEND_HOST}api/gainLoss/getSystemVarianceAudit`,
    FetchVMAC: `${APP_BACKEND_HOST}api/gainLoss/FetchVMAC`,
    FetchFlowCal: `${APP_BACKEND_HOST}api/gainLoss/FetchFlowCal`,
    GetReleaseIncidentData: `${APP_BACKEND_HOST}api/releaseincident/incidents`,
    GetReleaseIncidentFilterData: `${APP_BACKEND_HOST}api/releaseincident/filters`,
    GetApproversReleaseIncident: `${APP_BACKEND_HOST}api/releaseincident/GetApproversReleaseIncident`,
    AddComment: `${APP_BACKEND_HOST}api/SaveComment`,
    GetSystemData: `${APP_BACKEND_HOST}api/digmaster/list/getsystem`,
    CreateSystemPipeLineData: `${APP_BACKEND_HOST}api/digmaster/list/createpipeline`,
    CreateSystemData: `${APP_BACKEND_HOST}api/digmaster/list/createsystem`,
    Getpipeline: `${APP_BACKEND_HOST}api/digmaster/list/getpipeline`,
    UpdateDigMasterPipeline: `${APP_BACKEND_HOST}api/digmaster/list/updatepipeline/{listId}`,
    UpdateDigMasterSystem: `${APP_BACKEND_HOST}api/digmaster/list/updatesystem/{listId}`,
};

export const AppConstants = {
    AUTHTOKEN: "AUTH_TOKEN",
    MT_TIME_FORMATTER: "Canada/Mountain",
    CST_TIME_FORMATTER: "America/Chicago",
    NOMINATION_DATE_FORMAT: "DD-MMM",
    TOASTER_ERROR_TEXT: "error",
    TOASTER_SUCCESS_TEXT: "success",
    DIALOG_BOX_TITLE: "Please confirm",
    DIALOG_BOX_BODY: "Are you sure you want to save?",
    DIALOG_BOX_BODY_DELETE: "Are you sure you want to delete?",
    DIALOG_BOX_SURE: "Unsaved data will be lost. Do you want to proceed?",
    TOASTER_SUCCESS: "Saved Successfully",
    TOASTER_UPDATE: "Updated Successfully",
    TOASTER_EMAIL_SUCCESS: "Email Sent to Marketing Representative",
    TOASTER_Delete: "Record Deleted Successfully",
    TOASTER_ERROR_RETRIEVE_TEXT:
        "Data could not be retrieved. Please try again later",
    TOASTER_ERROR_SAVE_TEXT: "Data could not be saved. Please try again later",

    TOASTER_ERROR_REQUIRED_TEXT:
        "Please fill mandatory fields before submitting.",
    TOASTER_ERROR_DUPLICATE_TEXT:
        "The Data you are trying to save is duplicate.",
    TOASTER_ERROR_EXPORT: "Export Failed",
    GAINLOSS_TOASTER_ERROR_EFFECTIVESTARTDATE_FIRST_DAY_TEXT:
        "Effective Start Date can only be the first day of the month for an existing SubSystem",
    GAINLOSSREFERENCETOASTER_ERROR_DUPLICATE_TEXT:
        "The Reference Data you are trying to save is duplicate.",
    GAINLOSSPRODUCTTOASTER_ERROR_DUPLICATE_TEXT:
        "The Product Data you are trying to save is duplicate.",
    GAINLOSSREFERENCETOASTER_ERROR_SAVE_TEXT:
        "Reference Data could not be saved. Please try again later",
    GAINLOSSPRODUCTTOASTER_ERROR_SAVE_TEXT:
        "Product Data could not be saved. Please try again later",
    GAINLOSS_EABS_INTEGRATION: "EABS Integration has started",
    GAINLOSS_FBS_INTEGRATION: "FBS Integration has started",
    GAINLOSS_VMAC_INTEGRATION: "VMAC Integration has started",
    GAINLOSS_VMAC_PPA_INTEGRATION: "VMAC PPA Integration has started",
    GAINLOSS_FLOWCAL_INTEGRATION: "FlowCal Integration has started",
    GAINLOSS_EMAIL: "You will receive an email once it is completed",
    GAINLOSS_EABS_INTEGRATION_FAIL: "EABS Integration Failed",
    GAINLOSS_FBS_INTEGRATION_FAIL: "FBS Integration Failed",
    GAINLOSS_VMAC_INTEGRATION_FAIL: "VMAC Integration Failed",
    GAINLOSS_VMAC_PPA_INTEGRATION_FAIL: "VMAC PPA Integration Failed",
    GAINLOSS_FLOWCAL_INTEGRATION_FAIL: "FlowCal Integration Failed",
    GAINLOSS_HIGHWIRE_INTEGRATION: "HighWire Integration has started",
    GAINLOSS_HIGHWIRE_INTEGRATION_FAIL: "Highwire Integration Failed",
    GAINLOSS_VMACS_PPA_CURRENT_YEAR_JAN_MONTH_EXCEPTION: "Cannot fetch for current year's January month",
    APP_CLIENT_ID: window.hostName.APP_CLIENT_ID,
    TENANT_ID: window.hostName.TENANT_ID,
    AUTHORITY: window.hostName.AUTHORITY,
    POST_LOGOUT_REDIRECT_URI: window.hostName.POST_LOGOUT_REDIRECT_URI,
    REDIRECT_URI: window.hostName.REDIRECT_URI,
    API_GRANT_TYPE: "client_credentials",
    APP_BACKEND_HOST_KEY: window.hostName.APP_BACKEND_HOST_KEY,
    APP_REPORT_GROUP_ID: window.hostName.APP_REPORT_GROUP_ID,
    APP_REPORT_DATASET_ID: window.hostName.APP_REPORT_DATASET_ID,
    APP_AUTH_SCOPES_URL:
        "https://analysis.windows.net/powerbi/api/Report.Read.All",
    APP_AUTH_SCOPES_REFRESH_URL:
        "https://analysis.windows.net/powerbi/api/Dataset.ReadWrite.All",
    APP_AUTH_SCOPES_WS_URL:
        "https://analysis.windows.net/powerbi/api/Workspace.Read.All",
    GAIN_LOSS: {
        LISTS_SCREEN: {
            TOAST_MESSAGES: {
                CREATE_DUPLICATE_ERROR:
                    "The entity you are trying to create already exists. Duplicate entity cannot be created.",
                CREATE_GENERIC_ERROR:
                    "Entity creation failed. Unable to save data.",
                CREATE_SUCCESS: "The entity has been successfully created.",
                UPDATE_SUCCESS: "The entity has been successfully updated.",
                UPDATE_GENERIC_ERROR: "Unable to update entity.",
                UPDATE_DUPLICATE_ERROR:
                    "Unable to update entity. An entity with the same data already exists.",
            },
        },
        UNIT_PRICE_SCREEN: {
            TOAST_MESSAGES: {
                SYSTEM_DATA_ERROR:
                    "Unable to retrieve System data. Please try again later",
                SAVE_DUPLICATE_ERROR:
                    "The Unit Price data that you are trying to save has duplicate(s). Duplicate values cannot be created.",
                SAVE_GENERIC_ERROR:
                    "Unable to save Unit Price data. Please try again later.",
                EFFECTIVE_START_DATE_ERROR:
                    "Invalid effective start date value provided. Effective date should always start on the 1st of the month.",
                INVALID_SYSTEM_ERROR:
                    "Invalid System value provided. This system does not exist.",
                SAVE_SUCCESS: "Unit Price data has been saved successfully.",
            },
        },
        SYSTEM_VARIANCE_SCREEN: {
            TOAST_MESSAGES: {
                SAVE_DUPLICATE_ERROR:
                    "The System Variance data that you are trying to save has duplicate(s). Duplicate values cannot be created.",
                SAVE_GENERIC_ERROR:
                    "Unable to save System Variance data. Please try again later.",
                SAVE_SUCCESS:
                    "System Variance data has been saved successfully.",
            },
        },
    },
    DIGMASTER: {
        LISTS_SCREEN: {
            TOAST_MESSAGES: {
                CREATE_DUPLICATE_ERROR:
                    "The pipeline you are trying to create already exists. Duplicate pipeline cannot be created.",
                CREATE_GENERIC_ERROR:
                    "Pipeline creation failed. Unable to save data.",
                CREATE_SUCCESS: "The pipeline has been successfully created.",
                CREATE_SUCCESS_SYSTEM:
                    "The system has been successfully created.",
                UPDATE_SUCCESS: "The pipeline has been successfully updated.",
                UPDATE_SUCCESS_SYSTEM:
                    "The system has been successfully updated.",
                UPDATE_GENERIC_ERROR: "Unable to update pipeline.",
                UPDATE_DUPLICATE_ERROR:
                    "Unable to update pipeline. An pipeline with the same data already exists.",
            },
        },
        SYSTEMPIPELINEADD: {
            TOAST_MESSAGES: {
                CREATE_SUCCESS:
                    "The system pipeline has been successfully created.",
                CREATE_DUPLICATE_ERROR:
                    "The entity you are trying to create already exists. Duplicate entity cannot be created.",
                CREATE_GENERIC_ERROR:
                    "Entity creation failed. Unable to save data.",
                UPDATE_GENERIC_ERROR: "Unable to update systempipeline.",
            },
        },
        SYSTEMADD: {
            TOAST_MESSAGES: {
                CREATE_SUCCESS_SYSTEM:
                    "The system has been successfully created.",
                CREATE_DUPLICATE_ERROR:
                    "The entity you are trying to create already exists. Duplicate entity cannot be created.",
                CREATE_GENERIC_ERROR:
                    "Entity creation failed. Unable to save data.",
            },
        },
    },
    NGLSPOTPRICE_ERROR_SAVE_TEXT:
        "Spot Price Data could not be saved. Please try again later",
};

export const Types = {
    NUMBER: "number",
    DECIMAL: "decimal",
    TEXT: "Text",
    BOOLEAN: "boolean",
    DATE: "date",
    DATETIME: "datetime",
    DROPDOWN: "SmartSelect",
    DECIMALALLDIGITS: "DecimalAllDigits",
};

export const MarketingUserType = {
    PRIMARY: "primary",
    ALTERNATE: "alternate",
    ESCALATIONLEVEL1: "escalationlevel1",
    ESCALATIONLEVEL2A: "escalationlevel2A",
    ESCALATIONLEVEL2B: "escalationlevel2B",
};

export const GRAPH_REQUESTS = {
    LOGIN: {
        scopes: [AppConstants.APP_CLIENT_ID + "/.default"],
    },
    SIGNIN: {
        scopes: ["api://" + AppConstants.APP_CLIENT_ID + "/REFDATAFUNCTIONAPP.READALL"],
    },
    REPORT: {
        scopes: [AppConstants.APP_AUTH_SCOPES_URL],
    },
    REFRESH_REPORT: {
        scopes: [AppConstants.APP_AUTH_SCOPES_REFRESH_URL],
    },
    GETUSERS: {
        scopes: ["User.Read.All"],
    }
}